import { AuthLayout } from 'src/features/auth/components/AuthLayout';
import { LoginForm } from 'src/features/auth/components/LoginForm';

const Login = () => {
    return (
        <AuthLayout>
            <LoginForm />
        </AuthLayout>
    );
};

export { Login };
